import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { useGetTenantQuery, useGetTenantsQuery } from "../tenantSlice";
import { useParams } from "react-router-dom";
const TenantView = ({ id }) => {
    const routeParams = useParams();
    let { data: tenant, error, isLoading } = useGetTenantQuery(id ?? routeParams?.id);

    return (<Authorize profile={permissionProfiles.SAAS_MANAGEMENT.MANAGE_TENANTS}>
        <div>
            {tenant?.name}
        </div>
    </Authorize>)
}
export default TenantView;